import { useCallback, useContext } from 'react'

import { actionTypes } from 'state/actionTypes'
import { AppContext } from 'state/appContext'
import { ALLOW_DOMAIN_URL } from 'utils/post'

export function useLeavePageConfirm(url: string) {
  const { dispatch } = useContext(AppContext)

  const handleClick = useCallback(
    (e: any) => {
      const urlJs = new URL(url)
      const isInternalUrl = ALLOW_DOMAIN_URL.some((o) =>
        urlJs.origin.endsWith(o),
      )
      if (!isInternalUrl) {
        e.preventDefault()
        dispatch({
          type: actionTypes.SET_OPEN_CONFIRM_LEAVE_PAGE_POPUP,
          payload: url,
        })
      }
    },
    [url],
  )

  return {
    handleClick,
  }
}
